import React, { StrictMode } from "react";
import { Web3Provider } from "@ethersproject/providers";
import { Web3ReactProvider } from "@web3-react/core";
import Menu from "../components/Menu";
import MintTemplate from "../components/Mint/MintTemplate";
import "../App.css";
const getLibrary = (provider) => {
  const library = new Web3Provider(provider);
  return library;
};
const Mint = () => {
  return (
    <div>
      <Menu></Menu>
      <div
        className="mint-page"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/background/bg-banner.png)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        }}
      >
        <StrictMode>
          <Web3ReactProvider getLibrary={getLibrary}>
            <MintTemplate />
          </Web3ReactProvider>
        </StrictMode>
      </div>
    </div>
  );
};

export default Mint;
